import Image from 'next/image';
import LogoSrc from '@/assets/phonics-logo-small.png';

interface PhonicsLogoProps {
  className?: string;
}

export const PhonicsLogo = ({ className }: PhonicsLogoProps) => (
  <Image src={LogoSrc} alt="Pickatale Phonics Logo" className={className} />
);
